import Vue from 'vue';

import DateFilter from '../filters/DateFilter';
import NumberFilter from '../filters/NumberFilter';
import CurrencyFilter from '../filters/CurrencyFilter';
import PointFilter from '../filters/PointFilter';

Vue.use('date', DateFilter);
Vue.use('number', NumberFilter);
Vue.use('currency', CurrencyFilter);
Vue.use('point', PointFilter);